module.exports = __webpack_public_path__ + "static/media/1.d0fe4283.JPG";